import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "objectexportoption"
    }}>{`ObjectExportOption`}</h1>
    <p>{`Export options for the object`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the ObjectExportOption (a ObjectStyle, SplineItem, Polygon, GraphicLine, Rectangle, Oval, Group, TextFrame or EndnoteTextFrame).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`epubType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The epub type as recommended by IDPF`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`SizeTypeEnum `}<strong parentName="p">{`sizeType`}</strong>{` `}</p>
      <p parentName="blockquote">{`size settings to be used for the object`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`customSize`}</strong>{` `}</p>
      <p parentName="blockquote">{`Custom size applied to the object`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PreserveAppearanceFromLayoutEnum `}<strong parentName="p">{`preserveAppearanceFromLayout`}</strong>{` `}</p>
      <p parentName="blockquote">{`Preserve Appearance from Layout`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`SourceType `}<strong parentName="p">{`altTextSourceType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The source type of alternate text`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`SourceType `}<strong parentName="p">{`actualTextSourceType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The source type of actual text`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`customAltText`}</strong>{` `}</p>
      <p parentName="blockquote">{`The custom alternate text entered by the user`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`customActualText`}</strong>{` `}</p>
      <p parentName="blockquote">{`The custom actual text entered by the user`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`altMetadataProperty`}</strong>{` `}</p>
      <p parentName="blockquote">{`The metadata property to use as source of alternate text. Can return: Ordered array containing namespacePrefix:String, propertyPath:String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`actualMetadataProperty`}</strong>{` `}</p>
      <p parentName="blockquote">{`The metadata property to use as source of actual text. Can return: Ordered array containing namespacePrefix:String, propertyPath:String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`TagType `}<strong parentName="p">{`applyTagType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The tag type of page item`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ImageFormat `}<strong parentName="p">{`imageConversionType`}</strong>{` `}</p>
      <p parentName="blockquote">{`Allows user to select the image format for conversion`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ImageResolution `}<strong parentName="p">{`imageExportResolution`}</strong>{` `}</p>
      <p parentName="blockquote">{`The export resolution`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`GIFOptionsPalette `}<strong parentName="p">{`gifOptionsPalette`}</strong>{` `}</p>
      <p parentName="blockquote">{`The color palette for GIF conversion. Note: Not valid when image conversion is JPEG.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`gifOptionsInterlaced`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, generates interlaced GIFs. Note: Not valid  when image conversion is JPEG.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`JPEGOptionsQuality `}<strong parentName="p">{`jpegOptionsQuality`}</strong>{` `}</p>
      <p parentName="blockquote">{`The quality of converted JPEG images. Note: Not valid when image conversion is GIF.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`JPEGOptionsFormat `}<strong parentName="p">{`jpegOptionsFormat`}</strong>{` `}</p>
      <p parentName="blockquote">{`The formatting method for converted JPEG images. Note: Not valid  when image conversion is GIF.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ImageAlignmentType `}<strong parentName="p">{`imageAlignment`}</strong>{` `}</p>
      <p parentName="blockquote">{`Alignment applied to images`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`imageSpaceBefore`}</strong>{` `}</p>
      <p parentName="blockquote">{`Space Before applied to images`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`imageSpaceAfter`}</strong>{` `}</p>
      <p parentName="blockquote">{`Space After applied to images`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`useImagePageBreak`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, image page break settings will be used in objects`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ImagePageBreakType `}<strong parentName="p">{`imagePageBreak`}</strong>{` `}</p>
      <p parentName="blockquote">{`Image page break settings to be used with objects`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`customLayout`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, custom layout is enabled for object`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`CustomLayoutTypeEnum `}<strong parentName="p">{`customLayoutType`}</strong>{` `}</p>
      <p parentName="blockquote">{`Custom Layout settings to be used for object`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`altText`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Provides the alternate text for the object`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`actualText`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Provides the actual text for the object`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the ObjectExportOption.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ObjectExportOption `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      